export default "__VITE_ASSET__QhyuXsXk__"